import { Factory } from "@/data/dao/Factory";
import { CatalogDao } from "@/data/dao/service/CatalogDao";
import type { IFulfillmentGroup } from "@/data/model/FulfillmentGroup";
import { Format } from "@/data/util/Format";

import { translate } from "@/shared/localization/language";

import { i18n } from "@/portal/Trans";
import { DataTable, type IDataTableConfig } from "@/portal/elements/DataTable";
import { TableFilter } from "@/portal/elements/TableFilter";
import { portalEvents } from "@/portal/events/portalEvents";

export class FulfillmentGroupTableController {
    private $element: JQuery;
    private dao: CatalogDao;
    private dataTable: DataTable<IFulfillmentGroup>;
    private search: TableFilter;

    constructor(element: JQuery) {
        this.$element = element;

        this.dao = Factory.getInstance<CatalogDao>(CatalogDao);

        const tableConfig: IDataTableConfig<IFulfillmentGroup> = {
            columnMapping: [
                {
                    name: i18n("general.fields.designation"),
                    property: "internalName",
                    styles: { width: "40%" },
                    formatter: (m) => {
                        if (m.internalName !== undefined) return Format.htmlEscape(m.internalName);

                        return Format.htmlEscape(translate(m.name));
                    },
                },
                {
                    name: i18n("general.fields.internalNote"),
                    property: "internalNote",
                    styles: { width: "45%" },
                },
                {
                    name: i18n("general.fields.sort"),
                    property: "order",
                },
                {
                    name: "",
                    property: "id",
                    styles: { width: "110px", "text-align": "right" },
                    formatter: () => {
                        return $(
                            '<span><a class="btn btn-sm btn-clean btn-icon btn-icon-md"><i class="la la-edit"></i></a></span>'
                        );
                    },
                },
            ],
            filterProvider: {
                getFilter: () => this.search.getValue(),
                setFilter: (d) => this.search.setValue(d),
            },
            locationDependend: true,
            defaultSortProperty: "internalName",
        };

        this.search = new TableFilter().appendTo(this.$element.find("> .kt-portlet__body.tablefilter"));
        this.dataTable = new DataTable<IFulfillmentGroup>(
            this.$element.find("> .kt-portlet__body > .kt-datatable"),
            this.dao.fulfillmentGroupDataSource,
            tableConfig
        );
        this.dataTable.onClick(
            (m) => {
                location.href = "/fulfillmentgroup/" + m.id;
            },
            (m) => {
                window.open("/fulfillmentgroup/" + m.id);
            }
        );

        this.dataTable.listenTo(this.search);
        portalEvents.OnLocationChanged.add(() => {
            this.dataTable.loadData(true);
        }, this);
    }
}
